var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',[_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"top"},[_c('h1',[_vm._v(_vm._s(_vm.$tc('settings.integration', 0)))])]),_c('integration')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }